// extracted by mini-css-extract-plugin
module.exports = {"container":"reviewRules_container__2u6lf","box":"reviewRules_box__3DbQ_","flexBox":"reviewRules_flexBox__3Kvtx","LMSWindow":"reviewRules_LMSWindow__17ZAY"};